import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import Button from "../button/index.js";
import Card from "../card/index.js";

import styles from "./styles.module.scss";

const Modal = (props) => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    setShowModal(props.closeModal);
  }, [props.closeModal]);

  return (
    <>
      {showModal && (
        <div className={styles.modal}>
          <button
            className={styles.modalOverlay}
            onClick={() => {
              setShowModal(false);
              if (props.openModalButtonProps.onClick) {
                props.openModalButtonProps.onClick();
              }
            }}
          />
          <div className={styles.modalCardWrapper}>
            <Card
              headerProps={{
                heading: props.openModalButtonLabel
              }}
              profiling="border"
              {...props.openModalCardProps}
            >
              {props.children}
            </Card>
          </div>
        </div>
      )}
      <Button
        label={props.openModalButtonLabel}
        size="small"
        {...props.openModalButtonProps}
        onClick={() => {
          setShowModal(true);
          if (props.openModalButtonProps.onClick) {
            props.openModalButtonProps.onClick();
          }
        }}
      />
    </>
  );
};

Modal.propTypes = {
  children: PropTypes.node.isRequired,
  closeModal: PropTypes.bool,
  openModalButtonLabel: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]),
  openModalButtonProps: PropTypes.object,
  openModalCardProps: PropTypes.object
};

Modal.defaultProps = {
  closeModal: false,
  openModalButtonLabel: "Open modal",
  openModalButtonProps: {},
  openModalCardProps: {}
};

export default Modal;
